<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import { debounce } from "vue-debounce";
import MainBreadcrumbs from "@/ui/components/header/MainBreadcrumbs.vue";
import { useApiClient } from "@/api/client";
import RuleModelDTO = App.Data.RuleEngine.RuleModelDTO;
import { useBaseStore } from "@/stores/base";
import router from "@/router/router";

const breadcrumbs = [
	{
		title: "Rule Based Engine",
		disabled: true,
		to: "/rule-engine",
	},
];

const itemsPerPage = ref<number>(100);
const showNewModelDialog = ref<boolean>(false);

const headers = [
	{ title: "Uuid", key: "uuid", sortable: true },
	{ title: "Name", key: "name", sortable: true },
	{ title: "Versions", key: "versionCount", sortable: false },
];

const isLoading = ref<boolean>(false);
const items = ref<RuleModelDTO[]>([]);
const totalItemCount = ref<number>(0);
const page = ref<number>(1);
const sortBy = ref([]);

const loadItems = debounce(async ({ page, itemsPerPage, sortBy }) => {
	isLoading.value = true;

	const client = useApiClient("ruleEngine");

	const response = await client.index({ page, itemsPerPage, sortBy });

	if (response.isOk()) {
		items.value = response.value;
		totalItemCount.value = response.value.length;
	}

	isLoading.value = false;
}, 300);

onBeforeMount(() => {
	// If a rule_model_uuid is defined on the Environment, we use a single model implementation,
	// therefore, we can directly select the active model defined in the ui.
	if (useBaseStore().currentEnvironment.rule_model_uuid) {
		router.push({
			name: "pricingEngine.versions",
			params: {
				model_uuid: useBaseStore().currentEnvironment.rule_model_uuid,
			},
		});
	}
});
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" />

	<v-card>
		<v-card-text class="pa-0">
			<v-data-table-server
				v-model:items-per-page="itemsPerPage"
				v-model:page="page"
				v-model:sort-by="sortBy"
				:headers="headers"
				:items="items"
				:items-length="totalItemCount"
				:loading="isLoading"
				@update:options="loadItems"
			>
				<template v-slot:item.uuid="{ item }">
					<router-link
						class="router-link-primary"
						:to="{
							name: 'pricingEngine.versions',
							params: { model_uuid: item.uuid },
						}"
					>
						{{ item.uuid }}
					</router-link>
				</template>
				<template v-slot:item.name="{ item }">
					{{ item.name !== "" ? item.name : "Unknown" }}
				</template>
			</v-data-table-server>
		</v-card-text>
	</v-card>
</template>

<style scoped></style>
